var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "m--0", class: { "attendance-row": _vm.isAttended } },
    [
      _vm.isAttended
        ? _c(
            "b-col",
            { staticClass: "d-flex align-items-center", attrs: { cols: "2" } },
            [
              _c("div", { staticClass: "profpict inline--block" }, [
                _c("img", { attrs: { src: _vm.dataAttendance.image_url } })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAttended
        ? _c("b-col", { attrs: { cols: "10" } }, [
            _c("div", { staticClass: "label-chekin-today" }, [
              _vm._v("Yeah, you have check in today")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "proflocation" }, [
              _c("i", { staticClass: "fa fa-map-marker" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.dataAttendance.address))])
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "attendtime" }, [
              _vm._v(_vm._s(_vm.convertTimer(_vm.dataAttendance.check_in_time)))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAttended
        ? _c("b-col", { attrs: { cols: "2" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/fingerprint.png"),
                height: "40"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAttended
        ? _c("b-col", { attrs: { cols: "8" } }, [
            _c("span", [_vm._v("Oops, you haven't check in today")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { "font-weight": "bold", "font-size": "0.8em" } },
              [_vm._v("\n      Lets Check In!\n    ")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eba5510", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eba5510","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jAttendanceWidget.vue
// module id = null
// module chunks = 